import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { StpRegistrationStorageService } from '../../../services/stp-registration-storage.service';
import { InspectionOfficer } from 'src/app/modules/course-accreditation/models/inspectionOfficer';

@Component({
  selector: 'app-add-inspection-officer',
  templateUrl: './add-inspection-officer.component.html',
  styleUrls: ['./add-inspection-officer.component.scss']
})
export class AddInspectionOfficerComponent implements OnInit {

  inspectionOfficerForm!: FormGroup;
  inspectionOfficer: InspectionOfficer;
  inspectionOfficerId: number;
  contactNumberAlreadyExist = false;

  constructor(private fb: FormBuilder,
    private notification: NzNotificationService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private stpRegistrationService: StpRegistrationStorageService) {

      let inspectionOfficerId = this.activatedRoute.snapshot.params.id;
      this.inspectionOfficerId = inspectionOfficerId;

      if(this.inspectionOfficerId != null){
        this.getInspectionOfficerById(this.inspectionOfficerId);
      }
  }

  ngOnInit(): void {
    this.inspectionOfficerForm = this.fb.group({
      id: [null],
      name: ['', [Validators.required]],
      email: ['', [Validators.email, Validators.required]],
      phone: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],
      designation: ['']
    });
  }

  getInspectionOfficerById(inspectionOfficerId: number):void {
    this.stpRegistrationService.getInspectionOfficerById(inspectionOfficerId)
    .subscribe({
      next:(response)=>{
        if(response != null){
          this.inspectionOfficerForm.patchValue({
            id: response?.data?.id,
            name: response?.data?.name,
            email: response?.data?.email,
            phone: response?.data?.phone?.substring(1,11),
            designation: response?.data?.designation
          });
        }
      },
      error: (error) => this.notification.error('Failed', error)
    })
  }

  onSubmit(): void {
    let prefixWithNumber = '';

    if(this.inspectionOfficerForm.get('phone')?.value != null){
      prefixWithNumber = '0'+ this.inspectionOfficerForm.get('phone')?.value;
      this.inspectionOfficerForm.get('phone')?.setValue(prefixWithNumber);
    }

    this.inspectionOfficer = this.inspectionOfficerForm.value;

    this.stpRegistrationService.saveInspectionOfficer(this.inspectionOfficer)
    .subscribe(
      (response) => {
        if (response.success) {
          this.notification.success('Success!', response.message);
          this.router.navigate(['/home/stp-registration/inspection-officer-list']);
        }
        else {
          this.notification.error('Failed!', response.message);
        }
      },
      (error) => this.notification.error('Failed', error.error.message)
    );
  }

  //#region check unique contact number
  checkContactNumberIfExist(phone: any): void {
    this.contactNumberAlreadyExist = false;
    setTimeout(() => {
      if (phone.value.length == 10) {
        this.stpRegistrationService.checkContactNumberExist(this.inspectionOfficerId, phone.value)
          .subscribe({
            next: (res) => {
              if (res.success == true) {
                this.contactNumberAlreadyExist = false;
              } else {
                this.contactNumberAlreadyExist = true;
                this.inspectionOfficerForm.controls.phone.setErrors({
                  incorrect: true,
                });
              }
            },
          });
      }
    }, 100);
  }
  //#endregion
}
